<template>
<div id="reply-popup-content">
  <vs-popup :active.sync="popupConfig.isOpen" class="reply-popup"
   :title="`${this.reviewData.user_name} ${this.reviewData.customer && this.reviewData.customer.phone ? '- ' + StringHelper.phoneNumberFormat(this.reviewData.customer.phone) : ''}`">
    <div class="chat__narbar h-full">
      <section class="ps-container chat-content-scroll-area border border-solid d-theme-border-grey-light ps--theme_default ps--active-y overflow-auto" id="test_id">
        <div class="chat__log">
          <div id="component-chat-log" class="m-8">
            <div v-for="(reply, index) in messageListData" :key="index">
              <div class="msg-grp-container reply-msg-content" v-if="reply.is_sent == 0">
                <div class="spacer mt-8"></div>
                <div class="text-sm time-reply">{{getFormatDateTime(reply.sent_at)}}</div>
                <div class="flex items-start">
                  <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm border border-solid border-grey-light bg-white">
                    <span>{{reply.content}}</span>
                  </div>
                </div>
              </div>
              <div class="msg-grp-container reply-msg-content" v-else>
                <div class="spacer mt-8"></div>
                <div class="text-sm time-reply-you">{{getFormatDateTime(reply.sent_at)}}</div>
                <div class="flex items-start flex-row-reverse">
                  <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm bg-primary-gradient text-white">
                    <span>{{reply.content}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="chat__input flex p-4 mt-3 bg-white" slot="footer" >
        <vs-input class="flex-1" placeholder="Type Your Message" v-model="message" v-on:keyup.enter="Send"/>
        <vs-button class="bg-primary-gradient ml-4" type="filled" @click="Send">Send</vs-button>
      </div>
    </div>
  </vs-popup>
</div>
</template>

<script>
import moment from "moment";
import { StringHelper } from "../../../models/string_helper";
// import { EventSourcePolyfill } from "event-source-polyfill";
// import { domain, client_id } from "../../../axios";
// import * as md5 from "md5";
export default {
   name: 'popup-reply',
   props:{
    popupConfig: {
        type: Object,
        required: true
    },
    reviewData: {
      type: Object,
      required: true
    },
    // dataChange: {
    //   type: Object
    // }
   },
   data(){
     return {
       message: '',
       StringHelper,
      //  dataChange: { message: "", key: 0 },
     }
   },
   watch: {
    popupConfig: {
      immediate: true,
      deep: true,
      handler() {
          if(this.popupConfig.isOpen) {
            document.body.classList.add('overflow-hidden');
            if(this.reviewData && this.reviewData.user_id) {
              const obj = {
                customer_id : this.reviewData.user_id
              }
              this.$store.dispatch("reviewList/GET_SYSTEM_MESSAGE" , obj)
            }
            // this.subscribeTopic();
          } else {
            document.body.classList.remove('overflow-hidden');
            // this.eventSource.close();
          }
      },
    },
    messageListData: {
      immediate: true,
      deep: true,
      handler() {
        let ele = document.getElementById('test_id');
        if(ele) {
          setTimeout(() => {
            ele.scrollTo({top: ele.scrollHeight, behavior: 'smooth'})
          }, 50);
        }
      }
    },
    // dataChange: {
    //   immediate: true,
    //   deep: true,
    //   handler: function() {
    //     if (this.dataChange && this.dataChange.message != "") {
    //       // const obj = {
    //       //   // page: this.currentPage,
    //       //   // "per-page": this.itemsPerPage,
    //       //   keyword: this.search
    //       // };
    //       // if (this.filter.id != 1) {
    //       //   obj.type = this.filter.name;
    //       // }
    //       // if(this.sort_by.id == 2) {
    //       //   obj.sort = this.sort_by.name;
    //       // }
    //       // this.$store.dispatch("checkin/GET_CHECKIN_LIST", obj);
    //       console.log(this.dataChange);
    //       console.log(this.dataChange.message);
    //     }
    //   }
    // }
  },
  methods: {
    getFormatDateTime(date){
      return moment(date).format('lll');
    },
    Send(){
      if(this.message != '') {
        const obj = {
          customer_id: this.reviewData.user_id,
          content: this.message
        }
        this.$store.dispatch("reviewList/REPLY_GOCHECKIN_REVIEW", obj).then(() => {
          this.message = '';
        });
      }
    },
    // getDomain() {
    //   let temp = domain;
    //   if (domain[domain.length - 1] == "/") {
    //     temp = domain.slice(0, -1);
    //   }
    //   return temp.substring(temp.lastIndexOf("/") + 1);
    // },
    // subscribeTopic() {
    //   let topic = "/v1/gocheckin/customer";
    //   let hubUrl = "";
    //   let jwt = "";
    //   if (process.env.NODE_ENV == "development") {
    //     hubUrl = process.env.VUE_APP_DEVELOPMENT_MERCURE_HUB_URL;
    //     jwt = process.env.VUE_APP_DEVELOPMENT_MERCURE_JWT;
    //   } else {
    //     let mercure = JSON.parse(localStorage.getItem("appMercure"));
    //     hubUrl = mercure.hub_url;
    //     jwt = mercure.jwt;
    //   }
    //   const option = {
    //     headers: {
    //       Authorization: "Bearer " + jwt
    //     }
    //   };
    //   let id = md5(client_id);

    //   const u = new URL(hubUrl);
    //   u.searchParams.append("topic", id + "/" + this.getDomain() + topic);
    //   this.eventSource = new EventSourcePolyfill(u, option);
    //   this.eventSource.onmessage = e => {
    //     this.dataChange.message = JSON.parse(e.data);
    //     this.dataChange.key++;
    //     // console.log(this.dataChange)
    //   };
    // }
  },
  computed:{
    messageListData(){
      return this.$store.getters["reviewList/messageListData"];
    }
  },
  // created() {
  //   this.subscribeTopic();
  //   // const lastRecord = () => {
  //   //   this.$store.dispatch("checkin/CHECK_UPDATE").then(isUpdated => {
  //   //     if (isUpdated) {
  //   //       // const obj = {
  //   //       //   keyword: this.search
  //   //       // };
  //   //       // if (this.filter.id != 1) {
  //   //       //   obj.type = this.filter.name;
  //   //       // }
  //   //       // if(this.sort_by.id == 2) {
  //   //       //   obj.sort = this.sort_by.name;
  //   //       // }
  //   //       // this.$store.dispatch("checkin/GET_CHECKIN_LIST", obj);
  //   //     }
  //   //   });
  //   // };
  //   // lastRecord();
  //   // this.interval = setInterval(lastRecord, 10000);
  // },
  // destroyed() {
  //   clearInterval(this.interval);
  //   this.eventSource.close();
  // },
}
</script>
